<template>
  <div class="chart-container">
    <!-- 业务员选择器 -->
    <span class="title">最近6月业务员销售走势图</span>
    <div class="selector">
      <span class="label">业务员：</span>
      <el-select
          v-model="selectedEmployees"
          multiple
          placeholder="选择业务员"
          @change="updateChart"
          class="employee-selector"
      >
        <el-option
            v-for="(name, index) in employeeList"
            :key="index"
            :label="name"
            :value="name"
        ></el-option>
      </el-select>
    </div>
    <div ref="lineChart" class="chart" style="height: 400px;"></div>
  </div>
</template>

<script>
import * as echarts from 'echarts';

export default {
  name: 'SalesChart',
  data() {
    return {
      selectedEmployees: [], // 默认没有选中任何业务员
      employeeList: [], // 业务员列表
      salesData: [], // 销售数据
      chartInstance: null, // 图表实例
    };
  },
  methods: {
    // 获取后端的数据
    fetchData() {
        this.$http.get('/employeeRanking/customerRanking').then(response => {
          const data = response.data;

          // 检查返回的数据是否有效
          if (data && data.employeeSalesData) {
            const employeeSalesData = data.employeeSalesData;

            // 使用 Set 收集业务员名字（过滤掉 'month'）
            const employeeSet = new Set();
            employeeSalesData.forEach(item => {
              Object.keys(item).forEach(key => {
                if (key !== 'month') {
                  employeeSet.add(key);
                }
              });
            });

            // 将所有业务员名字存储为数组
            this.employeeList = Array.from(employeeSet);

            // 存储后端提供的销售数据
            this.salesData = employeeSalesData;

            // 如果有业务员，默认选中第一个业务员
            if (this.employeeList.length > 0) {
              this.selectedEmployees = [this.employeeList[0]];
            }

            // 初始化图表
            this.updateChart();
          } else {
            console.error('No valid data found in response');
          }
        });},





    // 格式化销售金额
    formatAmount(amount) {
      if (amount >= 10000) {
        return (amount / 10000).toFixed(1) + 'W'; // 超过1万用W表示，保留一位小数
      } else if (amount >= 1000) {
        return (amount / 1000).toFixed(1) + 'K'; // 超过1千用K表示
      } else {
        return amount; // 小于1千直接显示数字
      }
    },

    // 更新折线图
    updateChart() {
      // 整理选中的业务员的销售数据
      const selectedSalesData = this.salesData.map(monthData => {
        const sales = this.selectedEmployees.map(employee => {
          return monthData[employee] || 0; // 获取每个业务员的销售数据，默认值为0
        });
        return {
          month: monthData.month,
          sales,
        };
      });

      // 配置折线图的选项
      const option = {
        tooltip: {
          trigger: 'axis',
          formatter: (params) => {
            // 自定义tooltip显示内容，格式化销售金额
            let content = `${params[0].axisValue}<br/>`;
            params.forEach(item => {
              content += `${item.marker}${item.seriesName}: ${this.formatAmount(item.data)}<br/>`;
            });
            return content;
          },
        },
        legend: {
          data: this.selectedEmployees,
          orient: 'horizontal',
          top: '10px',
        },
        xAxis: {
          type: 'category',
          data: selectedSalesData.map(item => item.month), // 提取月份
          axisLabel: {
            rotate: 45,
            fontSize: 12,
          },
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: (value) => {
              // Y轴刻度格式化
              return value >= 10000
                  ? (value / 10000).toFixed(1) + 'W'
                  : value >= 1000
                      ? (value / 1000).toFixed(1) + 'K'
                      : value;
            },
          },
        },
        series: this.selectedEmployees.map((employee, index) => ({
          name: employee,
          type: 'line',
          smooth: true,
          data: selectedSalesData.map(item => item.sales[index]), // 使用每个业务员的销售数据
          lineStyle: {
            width: 2,
          },
          itemStyle: {
            borderWidth: 2,
          },
          symbol: 'circle', // 数据点显示为圆形
        })),
      };

      // 设置图表数据
      this.chartInstance.setOption(option);
    },
  },
  mounted() {
    // 初始化图表实例
    this.chartInstance = echarts.init(this.$refs.lineChart);
    this.fetchData(); // 获取数据并渲染图表
  },
  beforeDestroy() {
    // 销毁图表实例，避免内存泄漏
    if (this.chartInstance) {
      this.chartInstance.dispose();
    }
  },
};
</script>

<style scoped>
.chart-container {
  width: 100%;
  padding: 20px;
}

.title {
  font-size: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  color: #8c939d;
  margin: 10px 0;
}

.selector {
  margin-bottom: 20px;
  font-size: 16px;
}

.employee-selector {
  width: 80%;
}

.chart {
  width: 100%;
}

.el-select {
  font-size: 14px;
}

.el-select .el-input__inner {
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// SalesChart.vue?e8a8a188